import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";
import {getFullName} from "../../utils/PersonNameUtil";

const LiteraryWorksItemBrowserHeader = ({
                                             authorId,
                                             setAuthorId,
                                             ...restProps
                                         }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSelect
                    label="Автор"
                    selectedId={authorId}
                    setSelectedId={setAuthorId}
                    apiName2="artists"
                    specialOptions={[{id: 0, name: "(все)"},{id: -1, name: "(без автора)"}]}
                    showIds={true}
                    itemNameFunc={item => getFullName(item.first_name, item.last_name, item.middle_name)}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

export default LiteraryWorksItemBrowserHeader;